import Api from "../api/api";

export default async (body) => {
  const { data } = await Api.post("email/resend", body, {});
  return data;
};
